import { createRoot } from 'react-dom/client'
import './index.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'
import keycloak from './services/keycloak.service'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { ReactFlowProvider } from '@xyflow/react'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import { MUIThemeProvider } from './themes/useTheme'
import { AuthProvider } from './contexts/auth.context'
import { ToastProvider } from './contexts/toast.context'
import { PlaybookProvider } from './contexts/playbooks.context'
import { AppConfigProvider } from './contexts/app-config.context'
import { SchedulersProvider } from './contexts/schedulers.context'
import { SpectrumManagerProvider } from './contexts/spectrum.context'
import { RequestProvider } from './contexts/request.context'
import { RequestEquipmentProvider } from './contexts/request-equipment.context'

import './index.scss'

// Extend dayjs with the utc plugin
dayjs.extend(utc)

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ReactKeycloakProvider authClient={keycloak} autoRefreshToken={false}>
    <AppConfigProvider>
      <AuthProvider>
        <ReactFlowProvider>
          <ToastProvider>
            <PlaybookProvider>
              <SpectrumManagerProvider>
                <RequestProvider>
                  <RequestEquipmentProvider>
                    <SchedulersProvider>
                      <MUIThemeProvider>
                        <App />
                      </MUIThemeProvider>
                    </SchedulersProvider>
                  </RequestEquipmentProvider>
                </RequestProvider>
              </SpectrumManagerProvider>
            </PlaybookProvider>
          </ToastProvider>
        </ReactFlowProvider>
      </AuthProvider>
    </AppConfigProvider>
  </ReactKeycloakProvider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
